// extracted by mini-css-extract-plugin
export default {"root":"_1IRad4WrpXFZ-kTJKBc5x-","modal":"_2oWDvpk1N2jC2R7mXKKjts"};